import { createAction, props } from '@ngrx/store';
import { ApiError } from '@hrra/core';
import { JobseekerPrivacy } from 'src/app/jobseeker/shared/models/jobseeker-privacy-model';
import { JobseekerBlacklistUpdateViewModel, JobseekerBlackListViewModel, JobseekerChangePasswordViewModel, JobseekerEmailUpdateData, JobseekerPrivacyViewModel } from 'src/app/jobseeker/shared/services/jobseeker-settings.service';
import { ActionPayload } from "@hrra/core";
import { BasicOptionItem } from '@hrra/common-models';
import { JobseekerValidationCodeRequest } from './state';

export enum Actions{

    LoadJobseekerPrivacy = '[Jobseeker settings] Load jobseeker privacy',
    LoadJobseekerPrivacySuccess = '[Jobseeker settings] Load jobseeker privacy success',
    LoadJobseekerPrivacyFail = '[Jobseeker settings] Load jobseeker privacy fail',

    ChangeJobseekerPrivacy = '[Jobseeker settings] Change jobseeker privacy',
    CancelChanges = '[Jobseeker settings] Cancel jobseeker privacy changes',

    UpdateJobseekerPrivacy = '[Jobseeker settings] Update jobseeker privacy',
    UpdateJobseekerPrivacySuccess = '[Jobseeker settings] Update jobseeker privacy success',
    UpdateJobseekerPrivacyFail = '[Jobseeker settings] Update jobseeker privacy fail',

    ChangeJobseekerPassword = '[Jobseeker settings] Change jobseeker password',
    ChangeJobseekerPasswordSuccess = '[Jobseeker settings] Change jobseeker password success',
    ChangeJobseekerPasswordFail = '[Jobseeker settings] Change jobseeker password fail',
    
    CancelJobseekerPasswordChanges = '[Jobseeker settings] Cancel jobseeker password changes',
    ActivateJobseekerPasswordChanges = '[Jobseeker settings] Activate jobseeker password changes',
    ActivateJobseekerEmailChanges = '[Jobseeker settings] Activate jobseeker email changes',

    CancelJobseekerEmailChanges = '[Jobseeker settings] Cancel jobseeker email changes',

    LoadJobseekerBlacklist = '[Jobseeker settings] Load jobseeker blacklist',
    LoadJobseekerBlacklistSuccess = '[Jobseeker settings] Load jobseeker blacklist success',
    LoadJobseekerBlacklistFail = '[Jobseeker settings] Load jobseeker blacklist fail',

    SelectBlacklistItem = '[Jobseeker settings] Select blacklist item',
    RemoveSelectedBlacklistItem = '[Jobseeker settings] Remove selected blacklist item',
    CancelBlacklistChanges = '[Jobseeker settings] Cancel blacklist changes',

    UpdateEmail = '[Jobseeker settings] update email',
    UpdateEmailSuccess = '[Jobseeker settings] update email success',
    UpdateEmailFail = '[Jobseeker settings] update email fail',

    RequestVerificationCode = '[Jobseeker settings] request verification code',
    RequestVerificationCodeSuccess = '[Jobseeker settings] request verification code success',
    RequestVerificationCodeFail = '[Jobseeker settings] request verification code fail',

    UpdateUserEmail = '[Jobseeker settings] Update user email',
    UpdateUserEmailSuccess = '[Jobseeker settings] Update user email success',
    UpdateUserEmailFail = '[Jobseeker settings] Update user email fail',


    UpdateJobseekerBlacklist = '[Jobseeker settings] Update jobseeker blacklist',
    UpdateJobseekerBlacklistSuccess = '[Jobseeker settings] Update jobseeker blacklist success',
    UpdateJobseekerBlacklistFail = '[Jobseeker settings] Update jobseeker blacklist fail',

    StartVerificationTimer = '[Jobseeker settings] Start verification timer',
    TimerTick = '[Jobseeker settings] Timer tick',
    TimerFinished = '[Jobseeker settings] Timer finished',
    StopVerificationTimer = '[Jobseeker settings] Stop verification timer'
}

export const loadJobseekerPrivacy = createAction(
    Actions.LoadJobseekerPrivacy
);

export const loadJobseekerPrivacySuccess = createAction(
    Actions.LoadJobseekerPrivacySuccess,
    props<ActionPayload<JobseekerPrivacyViewModel>>()
);

export const loadJobseekerPrivacyFail = createAction(
    Actions.LoadJobseekerPrivacyFail,
    props<ActionPayload<ApiError>>()
);

export const changeJobseekerPrivacy = createAction(
    Actions.ChangeJobseekerPrivacy,
    props<ActionPayload<{privacyId: number}>>()
);

export const cancelChanges = createAction(
    Actions.CancelChanges
);

export const updateJobseekerPrivacy = createAction(
    Actions.UpdateJobseekerPrivacy,
    props<ActionPayload<{privacyId: number}>>()
);

export const updateJobseekerPrivacySuccess = createAction(
    Actions.UpdateJobseekerPrivacySuccess,
    props<ActionPayload<JobseekerPrivacyViewModel>>()
);

export const updateJobseekerPrivacyFail = createAction(
    Actions.UpdateJobseekerPrivacyFail,
    props<ActionPayload<ApiError>>()
);

export const changeJobseekerPassword = createAction(
  Actions.ChangeJobseekerPassword,
  props<ActionPayload<JobseekerChangePasswordViewModel>>()
);

export const changeJobseekerPasswordSuccess = createAction(
  Actions.ChangeJobseekerPasswordSuccess
);

export const changeJobseekerPasswordFail = createAction(
  Actions.ChangeJobseekerPasswordFail,
  props<ActionPayload<ApiError>>()
);

export const cancelJobseekerPasswordChanges = createAction(
    Actions.CancelJobseekerPasswordChanges
);

export const cancelJobseekerEmailChanges = createAction(
    Actions.CancelJobseekerEmailChanges
);

export const activateJobseekerPasswordChanges = createAction(
    Actions.ActivateJobseekerPasswordChanges
);

export const activateJobseekerEmailChanges = createAction(
    Actions.ActivateJobseekerEmailChanges
);

export const loadJobseekerBlacklist = createAction(
  Actions.LoadJobseekerBlacklist,
  props<ActionPayload<{ name: string }>>()
);

export const loadJobseekerBlackListSuccess = createAction(
  Actions.LoadJobseekerBlacklistSuccess,
  props<ActionPayload<JobseekerBlackListViewModel>>()
);

export const loadJobseekerBlacklistFail = createAction(
  Actions.LoadJobseekerBlacklistFail,
  props<ActionPayload<ApiError>>()
);

export const updateEmail = createAction(
  Actions.UpdateEmail,
  props<ActionPayload<{ newEmail: string; password: string }>>()
);

export const updateEmailSuccess = createAction(
  Actions.UpdateEmailSuccess,
  props<{ newEmail: string; password: string }>()
);

export const updateEmailFailure = createAction(
  Actions.UpdateEmailFail,
  props<{ error: any }>()
);

export const requestVerificationCode = createAction(
  Actions.RequestVerificationCode,
  props<{ newEmail: string, password: string }>()
);

export const requestVerificationCodeSuccess = createAction(
  Actions.RequestVerificationCodeSuccess,
  props<ActionPayload<JobseekerValidationCodeRequest>>()
);

export const requestVerificationCodeFail = createAction(
  Actions.RequestVerificationCodeFail,
  props<{ error: any }>()
);

export const updateUserEmail = createAction(
  Actions.UpdateUserEmail,
  props<ActionPayload<JobseekerEmailUpdateData>>()
);

export const updateUserEmailSuccess = createAction(
  Actions.UpdateUserEmailSuccess,
  props<ActionPayload<{newEmail: string}>>()
);

export const updateUserEmailFail = createAction(
  Actions.UpdateUserEmailFail,
  props<{ error: any }>()
);

export const selectBlackListItem = createAction(
  Actions.SelectBlacklistItem,
  props<ActionPayload<{ customer: BasicOptionItem }>>()
);

export const removeSelectedBlacklistItem = createAction(
  Actions.RemoveSelectedBlacklistItem,
  props<ActionPayload<{ customer: BasicOptionItem }>>()
);

export const cancelBlacklistChanges = createAction(
  Actions.CancelBlacklistChanges
);

export const updateJobseekerBlacklist = createAction(
  Actions.UpdateJobseekerBlacklist,
  props<ActionPayload<JobseekerBlacklistUpdateViewModel>>()
);

export const updateJobseekerBlacklistSuccess = createAction(
  Actions.UpdateJobseekerBlacklistSuccess,
  props<ActionPayload<JobseekerBlackListViewModel>>()
);

export const updateJobseekerBlacklistFail = createAction(
  Actions.UpdateJobseekerBlacklistFail,
  props<ActionPayload<ApiError>>()
)

// verification code countdown actions

export const startVerificationTimer = createAction(
  Actions.StartVerificationTimer
);

export const timerTick = createAction(
  Actions.TimerTick,
  props<{ seconds: number }>()
);

export const timerFinished = createAction(
  Actions.TimerFinished
);

export const stopVerificationTimer = createAction(
  Actions.StopVerificationTimer
);